
import { KeyWordServiceUtility } from "../Utility/KeyWordServiceUtility";


/// <summary>
/// 关键字搜索
/// </summary>
export class KeyWordSearchService {

	constructor() {
		this.count = -1;
		this.keyWord = null;
		this.level = -1;
		this.maxLat = -1;
		this.maxLon = -1;
		this.minLat = -1;
		this.minLon = -1;
		this.queryTerminal = "10000";
		this.queryType = -1;
		this.specifyAdminCode = null;
		this.start = -1;
		this.token=null;
		this.tdtURL=null;
	}


	/**
		 *检查参数是否赋值
		 */
	CheckParams() {
		if (this.keyWord == null) {
			return false;
		}

		if (this.level == -1) {
			return false;
		}

		if (this.maxLat == -1) {
			return false;
		}

		if (this.maxLon == -1) {
			return false;
		}

		if (this.minLat == -1) {
			return false;
		}

		if (this.maxLat == -1) {
			return false;
		}

		if(!this.token)
		{
			return false;
		}

		return true;
	}

	/**
	 *查询
	 */
	Query(succeedCallback, errorCallback) {
		let queryService = new KeyWordServiceUtility();
		this.SetBaseInfoServiceUtility(queryService);
		queryService.Query(succeedCallback, errorCallback);
	}

	/**
	 *设置服务Util 
	 * @param serviceUtil serviceUtil 不允许为空
	 */
	SetBaseInfoServiceUtility(serviceUtil) {
		if (serviceUtil == null) return;
		serviceUtil.count = this.count;
		serviceUtil.keyWord = this.keyWord
		serviceUtil.level = this.level;
		serviceUtil.start=this.start;
		serviceUtil.maxLat = this.maxLat;
		serviceUtil.maxLon = this.maxLon;
		serviceUtil.minLat = this.minLat;
		serviceUtil.minLon = this.minLon;
		serviceUtil.specifyAdminCode = this.specifyAdminCode;
		serviceUtil.queryTerminal = this.queryTerminal;
		serviceUtil.queryType = this.queryType;
		serviceUtil.token=this.token;
		serviceUtil.tdtURL=this.tdtURL;
	}

}//end KeyWordSearchService

